import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  RiskToleranceWorkflow = 'RiskToleranceWorkflow',
  RiskToleranceWorkflowResult = 'RiskToleranceWorkflowResult',
  OrionRiskIntelligenceWorkflow = 'OrionRiskIntelligenceWorkflow',
}

export const queryKeys = {
  riskToleranceWorkflow: (clientId: string) => [
    QueryFeature.RiskToleranceWorkflow,
    QueryKey.RiskToleranceWorkflow,
    clientId,
  ],

  riskToleranceWorkflowResult: (clientId: string) => [
    QueryFeature.RiskToleranceWorkflow,
    QueryKey.RiskToleranceWorkflowResult,
    clientId,
  ],

  orionRiskIntelligenceWorkflow: (clientId: number) => [
    QueryFeature.RiskToleranceWorkflow,
    QueryKey.RiskToleranceWorkflowResult,
    clientId,
  ],
};
